<template>
    <div v-if="studentKelulusan" class="materi-page">
        <div  class="container-fluid mt-1">
            <div class="row">
                <div class="col-xl-12 mb-5 mb-xl-0">
                    <card header-classes="bg-transparent" body-classes="bg-transparent p-0">
                        <div class="">
                            <div style="min-width: 1170px;" class="card shadow" :class="type === 'dark' ? 'bg-default': ''">
                                
                                <div class="p-2 text-center ">
                                    <h5>PUSAT KEGIATAN BELAJAR MASYARAKAT (PKBM)</h5>
                                </div>
                                <img
                                class="img-kelulusan"
                                src="../../../assets/img/logo-daring.png"
                                alt="Logo"
                            />
                                <div style="margin-top:-23px" class="p-2 text-center ">
                                    <h3>BINA PANDU MANDIRI</h3>
                                </div>
                                <div style="margin-top:-23px" class="p-2 text-center ">
                                    <h5>Skep. 421.9/Kpts.304 –Disdikbud/2015</h5>
                                </div>
                                <div style="margin-top:-23px" class="p-2 text-center ">
                                    <h5>Akta Notaris Nevie Alifah Assegaf, S.H, M.H No. 22 Tanggal 15 Oktober 2015</h5>
                                </div>
                                <div style="margin-top:-23px" class="p-2 text-center ">
                                    <p><b>Alamat: Jln. Jend.Ahmad Yani No. 136 Ciamis. e-mail: binapandumandiri@gmail.com</b></p>
                                </div>
                                <hr class="new1" style="border: 2px solid black;">
                                <div class="p-2 text-center ">
                                    <h5>SURAT KETERANGAN LULUS</h5>
                                    <p><b>Nomor: {{studentKelulusan.no_surat}}</b></p>
                                </div>
                                <div class="p-2 text-left ">
                                    <p><b>Yang bertanda tangan di bawah ini Ketua Pusat Kegiatan Belajar Masyarakat Bina Pandu Mandiri Kabupaten Ciamis Provinsi Jawa Barat, menerangkan bahwa:</b></p>
                                </div>
                                <div class="p-2 text-center ">
                                    <div style="overflow-x:auto;" v-if="!isBusy">
                                        <table class="">
                                            <tbody>
                                                <tr class="text-left">
                                                    <td >Nama</td>
                                                    <td >: {{studentKelulusan.full_name}}</td>
                                                </tr>
                                                <tr class="text-left">
                                                    <td >Tempat Tanggal Lahir</td>
                                                    <td >: {{studentKelulusan.ttl}}</td>
                                                </tr>
                                                <tr class="text-left">
                                                    <td >Nomor Induk</td>
                                                    <td >: {{studentKelulusan.no_induk}}</td>
                                                </tr>
                                                <tr class="text-left">
                                                    <td >Nama Orang Tua</td>
                                                    <td >: {{studentKelulusan.parent_name}}</td>
                                                </tr>
                                                <tr class="text-left">
                                                    <td >Nomor Induk Siswa Nasional</td>
                                                    <td >: {{studentKelulusan.nis_nas}}</td>
                                                </tr>
                                                <tr class="text-left">
                                                    <td >Alamat Peserta Didik</td>
                                                    <td >: {{studentKelulusan.address}}</td>
                                                </tr>
                                                <tr class="text-left">
                                                    <td >Satuan Pendidikan Penyelenggara Ujian</td>
                                                    <td >: PKBM BINA PANDU MANDIRI</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div v-if="isBusy" class="text-center text-danger my-2">
                                        <img class="img-loading" src="../../../assets/img/logo-daring.png" alt="Logo"/><br>
                                    <b-spinner class="align-middle"></b-spinner>
                                    </div>
                                </div>
                                <div class="p-2 text-center ">
                                    <h1><b>LULUS</b></h1>
                                </div>
                                <div class="p-2 text-left ">
                                    <p><b>dari satuan pendidikan program Paket {{studentKelulusan.class_name}} berdasarkan hasil Ujian Pendidikan Kesetaraan telah memenuhi kriteria sesuai dengan peraturan perundang-undangan dengan rincian nilai ujian nasional sebagai berikut:</b></p>
                                    <div style="overflow-x:auto;" v-if="!isBusy">
                                        <table id="student-progress" class="table table-perkembangan"
                                            :current-page="currentPage"
                                            :per-page="perPage"
                                            :filter="filter"
                                            :filter-included-fields="filterOn"
                                            :sort-direction="sortDirection"
                                            responsive="sm"
                                            show-empty
                                            small
                                            @filtered="onFiltered"
                                        >
                                            <thead>
                                                <tr v-for="(item, index) in studentKelulusan.header" :key="index">
                                                    <th class="t-column-header" v-bind:rowspan="column.rowspan" v-bind:colspan="column.colspan" v-for="(column, indexColumn) in item.columns" :key="indexColumn">{{column.label}}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="!studentKelulusan.body" class="text-center">
                                                    <td colspan="15">Data tidak ditemukan</td>
                                                </tr>
                                                <tr v-else v-for="(item, index) in studentKelulusan.body" :key="index">
                                                    <td class="t-column-body" v-for="(column, indexColumn) in item.columns" :key="indexColumn">{{column.label}}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="p-2 text-left ">
                                    <p><b>Surat keterangan ini berlaku sampai dengan diterbitkannya ijazah yang sah. Jika dikemudian hari terdapat kesalahan dalam penulisan surat keterangan ini, akan diperbaiki sebagaimana mestinya.</b></p>
                                </div>
                                <div class="p-2 text-left w-ttd">
                                    <p><b>Ciamis, {{studentKelulusan.ttd_date}}</b></p>
                                    <p style="margin-top:-20px;margin-bottom:60px;"><b>Ketua PKBM Bina Pandu Mandiri,</b></p>
                                    <p><b>{{studentKelulusan.ttd_name}}</b></p>
                                </div>
                            </div>
                        </div>
                    </card>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    export default {
        props: {
            type: {
                type: String,
                default: null
            },
        },
        components: {
        },
        data() {
            return {
                subjectId: this.$route.params.subjectId,
                isBusy: false,
                showLoader: false,
                items: [],
                fields: [
                    { key: 'name', label: 'Nama Lengkap', sortable: true, sortDirection: 'desc', class: 'text-left' },
                    { key: 'absence', label: 'Keterangan', sortable: false, class: 'text-center'}
                ],
                filter_form: {
                    activityId: null,
                },
                totalRows: 1,
                currentPage: 1,
                perPage: 25,
                pageOptions: [25, 50, 100, 200, 400, 800, 1000],
                sortBy: '',
                sortDesc: false,
                sortDirection: 'asc',
                filter: null,
                filterOn: []
            }
        },
        computed: {
            ...mapGetters({
                studentKelulusan: 'getStudentKelulusan',
                token: 'getToken'
            })
        },
        watch: {
            //
        },
        methods: {
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
            },
            async getStudentKelulusan() {
                this.isBusy = true
				await this.$store.dispatch('getStudentKelulusan')
					.then(() => {
                        this.isBusy = false
					})
					.catch((err)=> {
                        this.isBusy = false
						this.$swal.fire('Failed', err.response.data.message, 'error')
					})
			},
        },
        destroyed() {
            let resp = null
            this.$store.commit('setStudentKelulusan', { resp })
        },
        mounted() {
            this.totalRows = this.studentKelulusan.length
        },
        async created() {
            this.getStudentKelulusan();
        }
    }
</script>
<style>
.w-ttd{
    width:340px;
    margin-left:1200px;
}
@media only screen and (max-width: 1796px) {
  .w-ttd{
        width:340px;
        margin-left:1150px;
    }
}
@media only screen and (max-width: 1696px) {
  .w-ttd{
        width:340px;
        margin-left:1000px;
    }
}
@media only screen and (max-width: 1686px) {
  .w-ttd{
        width:340px;
        margin-left:1000px;
    }
}
@media only screen and (max-width: 1496px) {
  .w-ttd{
        width:340px;
        margin-left:850px;
    }
}
.img-kelulusan {
    position: absolute;
    left:30px;
    z-index: 999;
    top: 10px;
    height: 150px;
    width: 150px;
}
.task-name {
    padding-right: 0 !important;
}
.table-perkembangan {
    width: 60%;
    margin: 20px auto;
    table-layout: auto;
    border: 1px solid #555;
    border-width: 0 1px 0 1px;
}
.t-column-header {
    border: 1px solid #555;
    border-width: 0px 1px 0px 1px;
}
.t-column-body {
    border: 1px solid #555;
    border-width: 1px 1px 1px 1px;
}

</style>
<style lang="css" scoped>
.btn-primary {
    color: #fff;
    background-color: #ca062a;
    border-color: #ca062a;
}
.table-responsive {
    margin-bottom: 0;
}
.btn-primary:hover, .btn-primary:not(:disabled):not(.disabled):active, .btn-primary:focus {
    color: #fff;
    background-color: #ca062a;
    border-color: #ca062a;
    -webkit-box-shadow: unset;
    box-shadow: unset;
}
#student-progress {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#student-progress td, #student-progress th {
  border: 1px solid #ddd;
  padding: 8px;
}

#student-progress tr:nth-child(even){background-color: #f2f2f2;}

#student-progress tr:hover {background-color: #ddd;}

#student-progress th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: center;
  background-color: #d40000;
  color: white;
}
</style>